import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Schemas } from "../../../schemas";
import z from "zod";
import { alertEventsService } from "../../../services/alertEventsService";

const schema = Schemas.alertEvent.omit({ id: true, timestamp: true }).extend({count: z.string().transform(Number)});

export const useCreateAlertEvent = (alertId: string) => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (input: Omit<z.infer<typeof schema>, "count"> & {count: string}) => {
      const parsed = schema.parse(input);
      return alertEventsService.create({
        ...parsed,
        count: parsed.count ?? 1,
      });
    },
    onSuccess: () => {
      qc.invalidateQueries({queryKey: ["alert-events", alertId]});
      qc.invalidateQueries({queryKey: ["service-events"]});
      qc.invalidateQueries({queryKey: ["serviceMapId"]});
      qc.invalidateQueries({queryKey: ["dashboards"]});
    },
  });
};
